import React from "react";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { motion } from "framer-motion";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import styles from "./SlideGroup.module.css";
import "./navigationButton.css";
import Modal from "@material-ui/core/Modal";
import ProgramDetail from "../modal/ProgramDetail";
import { Program, RelatedVideo, Video } from "../../../stores/program/model/Program";
import { useHistory } from "react-router-dom";
import LinearProgress from "@material-ui/core/LinearProgress";
import { UserVideo } from "../../homePage/model/HomePage";
import PuiTooltip from "../../../components/elements/PuiTooltip ";
import { createStyles, makeStyles } from "@material-ui/core";

SwiperCore.use([Navigation]);

//スライドの型定義
export interface SlideGroupProps {
    //一列に表示させる画像数
    displayNum: number;
    //画像の間隔
    slideBetween?: number;
    //画像のループ切り替え
    needLoop: boolean;
    //id
    id: string;
    //スライドタイトル
    title: string;
    //スライドサムネイル
    imageUrl?: string;
    // プログラム詳細説明文
    description?: string;
    //プログラムリスト（受講中プログラム表示）
    programList?: Program[];
    //ビデオリスト
    videoList?: Video[];
    // 関連ビデオ
    relatedVideoList?: RelatedVideo[];
    //ビデオリスト（モーダル画面非表示）
    // videoListTransition?: Video[];
    videoListTransition?: VideoListTransition[];
    // ユーザー履歴
    userVideo?: UserVideo[];
}

//ビデオリスト（モーダル画面非表示）型定義
export interface VideoListTransition {
    //id
    id: string;
    //ビデオタイトル
    title: string;
    //ビデオサムネイル
    imageUrl: string;
    durationMillis?: number;
    progressMillis?: number;
    // 新着マーク
    visibleNewIcon?: boolean;
}

const useStyles = makeStyles(() =>
    createStyles({
        barColorPrimary: {
            backgroundColor: "va(--main)",
            height: "2px",
        },
    })
);

export default function SlideGroup({ ...props }: SlideGroupProps) {
    const classes = useStyles();

    //スライド要素の間隔
    const slideBetween = props.slideBetween ? props.slideBetween : 5;

    const [open, setOpen] = React.useState(false);
    const [selectedVideo, setSelectedVideo] = React.useState<Video>();
    const [videos, setVideos] = React.useState<Video[]>();
    const [related, setRelated] = React.useState<RelatedVideo[]>();
    const [title, setTitle] = React.useState("");
    const [des, setDes] = React.useState("");
    const history = useHistory();

    // 視聴履歴の進捗インジケータを計算
    const normalise = (row: any) => {
        if (row.viewingActivities.length === 0) {
            return 0;
        } else {
            const progressMillis = row.viewingActivities[0].progressMillis;
            const isFinished = row.viewingActivities[0].isFinished;
            if (progressMillis !== null) {
                const rate = Math.floor(
                    (Number(progressMillis) / Number(row.durationMillis)) * 100
                );
                return rate;
            } else if (progressMillis === null && isFinished) {
                return 100;
            }
        }
    };

    const handleOpen = (value: any) => {
        setOpen(true);
        // セレクトビデオエリアの画像変更
        const selectId: string = value.target.id;
        // ビデオをクリック
        if (props.videoList !== undefined && props.programList === undefined) {
            for (let i = 0; i < props.videoList.length; i++) {
                if (props.videoList[i].id === selectId) {
                    setSelectedVideo(props.videoList[i]);
                }
            }
            // プログラムをクリック
        } else if (props.videoList === undefined && props.programList !== undefined) {
            for (let i = 0; i < props.programList.length; i++) {
                if (props.programList[i].id === selectId) {
                    // フォーカスビデオをセット
                    const selectedOne = selectVideo(props.programList[i].videos);
                    setSelectedVideo(selectedOne);
                    // その他のパラメータをセット
                    setVideos(props.programList[i].videos);
                    setRelated(props.programList[i].relatedVideos);
                    setDes(props.programList[i].description);
                    setTitle(props.programList[i].title);
                }
            }
        }
    };

    // フォーカスされたビデオを決める
    const selectVideo = (videos: Video[]) => {
        if (videos.length === 1) {
            return videos[0];
        }
        if (videos.length > 1) {
            // 最新履歴の日付をとる（時間）
            const latestDate = Math.max(
                ...videos.map((item) => {
                    if (item.viewingActivities.length > 0) {
                        return Date.parse(item.viewingActivities[0].created);
                    } else {
                        return -1;
                    }
                })
            );
            for (let j = 0; j < videos.length; j++) {
                // 視聴していないビデオをスキップ
                if (videos[j].viewingActivities.length === 0) continue;
                const date = Date.parse(videos[j].viewingActivities[0].created);
                const isFinished = videos[j].viewingActivities[0].isFinished;
                if (date === latestDate && !isFinished) {
                    const latest = videos[j];
                    return latest;
                } else if (date === latestDate && isFinished) {
                    const index = j;
                    if (index === videos.length - 1) return videos[0];
                    const next = videos[j + 1];
                    return next;
                }
            }
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {/* 表示項目 */}
            {(() => {
                // プログラム一覧
                if (
                    props.videoList !== undefined &&
                    props.videoList.length > 0 &&
                    props.programList === undefined
                ) {
                    return (
                        <div>
                            <Swiper
                                spaceBetween={slideBetween}
                                slidesPerView={props.displayNum}
                                loop={
                                    props.needLoop
                                        ? props.videoList?.length >= props.displayNum
                                            ? true
                                            : false
                                        : false
                                }
                                loopFillGroupWithBlank={
                                    props.needLoop
                                        ? props.videoList?.length >= props.displayNum
                                            ? false
                                            : true
                                        : true
                                }
                                navigation={{
                                    nextEl: ".swiper-button-next",
                                    prevEl: ".swiper-button-prev",
                                }}
                                style={{ width: "100%" }}
                            >
                                {/* 表示項目:ビデオ単位 */}
                                {props.videoList?.map((row) => (
                                    <SwiperSlide key={`videoSlide-${row["id"]}`}>
                                        <motion.div
                                            whileHover={{ scale: 1.05 }}
                                            className={styles.slideDiv}
                                            style={{ position: "relative", zIndex: 9999 }}
                                        >
                                            {row.visibleNewIcon && (
                                                <img
                                                    src={require("../../../assets/image/newIcon.svg")}
                                                    className={styles.newIcon}
                                                    alt={`newIcon_${row["id"]}`}
                                                />
                                            )}
                                            <img
                                                id={row["id"]}
                                                src={
                                                    process.env.REACT_APP_API_ENDPOINT +
                                                    row["imageUrl"]
                                                }
                                                className={styles.slideImg}
                                                alt={row["id"]}
                                                onClick={handleOpen}
                                            />
                                            <LinearProgress
                                                className={styles.progressBar}
                                                classes={{
                                                    barColorPrimary: classes.barColorPrimary,
                                                }}
                                                variant="determinate"
                                                value={normalise(row)}
                                            />
                                            <div
                                                id={row["id"]}
                                                data-tip={row["title"]}
                                                data-for="programlist"
                                                className={styles.slideTitle}
                                                onClick={handleOpen}
                                            >
                                                {row["title"]}
                                            </div>
                                        </motion.div>
                                    </SwiperSlide>
                                ))}
                                {/* 送りボタン */}
                                {/* <div style={{height: "99%", top: "7%"}} className="swiper-button-next swiper-button-white swiper-button-disabled"></div>
                                <div style={{height: "99%", top: "7%"}} className="swiper-button-prev swiper-button-white swiper-button-disabled"></div> */}
                            </Swiper>
                            {/* Tooltip */}
                            <PuiTooltip id={"programlist"} />
                            <Modal
                                aria-labelledby="spring-modal-title"
                                aria-describedby="spring-modal-description"
                                className={styles.modal}
                                // style={{overflowY:'auto'}}
                                open={open}
                                onClose={handleClose}
                                closeAfterTransition
                            >
                                <ProgramDetail
                                    in={open}
                                    title={props.title}
                                    description={props.description}
                                    episodelist={props.videoList}
                                    selected={selectedVideo}
                                    related={props.relatedVideoList}
                                />
                            </Modal>
                        </div>
                    );
                    //受講中プログラム
                } else if (
                    props.videoList === undefined &&
                    props.programList !== undefined &&
                    props.programList.length > 0
                ) {
                    return (
                        <div>
                            <Swiper
                                spaceBetween={slideBetween}
                                slidesPerView={props.displayNum}
                                loop={
                                    props.needLoop
                                        ? props.programList?.length >= props.displayNum
                                            ? true
                                            : false
                                        : false
                                }
                                loopFillGroupWithBlank={
                                    props.needLoop
                                        ? props.programList?.length >= props.displayNum
                                            ? false
                                            : true
                                        : true
                                }
                                navigation={{
                                    nextEl: ".swiper-button-next",
                                    prevEl: ".swiper-button-prev",
                                }}
                            >
                                {/* 表示項目:プログラム単位 */}
                                {props.programList?.map((row) => (
                                    <SwiperSlide key={`programSlide-${row.id}`}>
                                        <motion.div
                                            whileHover={{ scale: 1.05 }}
                                            className={styles.slideDiv}
                                        >
                                            <img
                                                id={row["id"]}
                                                src={
                                                    process.env.REACT_APP_API_ENDPOINT +
                                                    row["showImageUrl"]
                                                }
                                                // src={process.env.REACT_APP_API_ENDPOINT + row["imageUrl"]}
                                                className={styles.slideImg}
                                                alt={row["id"]}
                                                onClick={handleOpen}
                                            />
                                            <div
                                                id={row["id"]}
                                                data-tip={row["title"]}
                                                data-for="learning"
                                                className={styles.slideTitle}
                                                style={{ bottom: "0%" }}
                                                onClick={handleOpen}
                                            >
                                                {row["title"]}
                                            </div>
                                        </motion.div>
                                    </SwiperSlide>
                                ))}

                                {/* 送りボタン
                                <div style={{height: "103%", top: "7%"}} className="swiper-button-next swiper-button-white"></div>
                                <div style={{height: "103%", top: "7%"}} className="swiper-button-prev swiper-button-white"></div> */}
                            </Swiper>
                            {/* Tooltip */}
                            <PuiTooltip id={"learning"} />
                            <Modal
                                aria-labelledby="spring-modal-title"
                                aria-describedby="spring-modal-description"
                                className={styles.modal}
                                open={open}
                                onClose={handleClose}
                                closeAfterTransition
                            >
                                <ProgramDetail
                                    in={open}
                                    title={title}
                                    description={des}
                                    episodelist={videos}
                                    selected={selectedVideo}
                                    related={related}
                                />
                            </Modal>
                        </div>
                    );
                }
                // ビデオリスト（押下してビデオ再生画面に遷移）
                // else if(videoTrans && videoTrans.length > 0){
                else if (
                    props.videoListTransition !== undefined &&
                    props.videoListTransition.length > 0
                ) {
                    return (
                        <div>
                            <Swiper
                                spaceBetween={slideBetween}
                                slidesPerView={props.displayNum}
                                loop={
                                    props.needLoop
                                        ? props.videoListTransition.length >= props.displayNum
                                            ? true
                                            : false
                                        : false
                                }
                                loopFillGroupWithBlank={
                                    props.needLoop
                                        ? props.videoListTransition.length >= props.displayNum
                                            ? false
                                            : true
                                        : true
                                }
                                navigation={{
                                    nextEl: ".swiper-button-next",
                                    prevEl: ".swiper-button-prev",
                                }}
                            >
                                {props.videoListTransition.map((row, index) => (
                                    <SwiperSlide key={`recordSlide-${index}`}>
                                        <motion.div
                                            whileHover={{ scale: 1.05 }}
                                            className={styles.slideDiv}
                                            style={{ position: "relative", zIndex: 9999 }}
                                        >
                                            {row.visibleNewIcon && (
                                                <img
                                                    src={require("../../../assets/image/newIcon.svg")}
                                                    className={styles.newIcon}
                                                    alt={`newIcon_${row["id"]}`}
                                                />
                                            )}
                                            <img
                                                id={row["id"]}
                                                src={
                                                    process.env.REACT_APP_API_ENDPOINT +
                                                    row["imageUrl"]
                                                }
                                                className={styles.slideImg}
                                                alt={row["id"]}
                                                onClick={() =>
                                                    history.push({
                                                        pathname: "./video/" + row.id,
                                                        state: { time: row.progressMillis },
                                                    })
                                                }
                                                onError={(e) =>
                                                    (e.currentTarget.src = require("../../../assets/image/NoImage.jpg"))
                                                }
                                            />
                                            <div
                                                id={row["id"]}
                                                data-tip={row["title"]}
                                                data-for="record"
                                                className={styles.slideTitle}
                                                onClick={() =>
                                                    history.push({
                                                        pathname: "./video/" + row.id,
                                                        state: { time: row.progressMillis },
                                                    })
                                                }
                                            >
                                                {row["title"]}
                                            </div>
                                            <LinearProgress
                                                className={styles.progressBar}
                                                classes={{
                                                    barColorPrimary: classes.barColorPrimary,
                                                }}
                                                variant="determinate"
                                                value={normalise(row)}
                                            />
                                        </motion.div>
                                    </SwiperSlide>
                                ))}
                                {/* 送りボタン
                                <div style={{height: "99%", top: "7%"}} className="swiper-button-next swiper-button-white"></div>
                                <div style={{height: "99%", top: "7%"}} className="swiper-button-prev swiper-button-white"></div> */}
                            </Swiper>
                            {/* Tooltip */}
                            <PuiTooltip id={"record"} />
                        </div>
                    );
                } else {
                    return;
                }
            })()}
        </>
    );
}
